import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ReviewCompany from './ReviewCompany';
import CompanyListCard from './CompanyListCard';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import SvgIcon from '../common/SvgIcon';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import config from '../../config/index';
import AddPersonComponent from './AddPersonComponent';
import NumberUtils from '../../utils/NumberUtils';
import LoaderComponent from '../common/LoaderComponent';

let theirSortCode = false;
let theirAccountNumber = false;
let companyResponse = {};
let detailsforManualEntry = {
  companyText: '',
  sortCode: '',
  accountNumber: '',
};

const NO_RESULTS_FOUND = 'No results found.';
class AddCompanyComponent extends React.Component {
  constructor(props) {
    super(props);
    this.goToMoveMoneyPage = this.goToMoveMoneyPage.bind(this);
    this.goBackToMoveMoney = this.goBackToMoveMoney.bind(this);
    this.goBackToSearchCompany = this.goBackToSearchCompany.bind(this);
    this.onCompanyStoreChange = this.onCompanyStoreChange.bind(this);
    this.updateValueState = this.updateValueState.bind(this);
    this.goToManagePayees = this.goToManagePayees.bind(this);
    this.onInputCompanyChange = this.onInputCompanyChange.bind(this);
    this.findCompanyButton = this.findCompanyButton.bind(this);
    this.dataChange = this.dataChange.bind(this);
    this.continueButton = this.continueButton.bind(this);
    this.accountNumSortCodeField = this.accountNumSortCodeField.bind(this);
    this.onAlternativeChange = this.onAlternativeChange.bind(this);
    this.onAlternativeBlur = this.onAlternativeBlur.bind(this);
    this.closeCompanyError = this.closeCompanyError.bind(this);
    this.enterManually = this.enterManually.bind(this);
    this.showHeader = this.showHeader.bind(this);
    this.checkError = this.checkError.bind(this);
    this.getResultText = this.getResultText.bind(this);
    this.removeHypenFromString = this.removeHypenFromString.bind(this);
    this.displayContinueButton = this.displayContinueButton.bind(this);
    this.changeSearchOptions = this.changeSearchOptions.bind(this);
    this.displaySearchButton = this.displaySearchButton.bind(this);
    this.companySearchField = this.companySearchField.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.showCopComponent = this.showCopComponent.bind(this);

    this.state = {
      name: '',
      sort_code: '',
      display_name: '',
      reference: '',
      account_number: '',
      inputValue: '',
      searchData: [],
      enableDiv: false,
      continueClick: false,
      selectedCompany: '',
      companyListError: false,
      companyErrorResponse: '',
      showAddCompany: false,
      loaderCss: '',
      addPayeeManuallyFlag: this.props.addPayeeManuallyFlag,
      errorExistAcctNo: false,
      errorExistSortCode: false,
      enableSearch: false,
      companySearchValue: '',
      emptySortCode: false,
      emptyAcctNo: false,
      isSearchByCompany: true,
      showLoader: false,
      isFindButton: false,
    };
  }

  componentWillMount() {
    theirSortCode = false;
    theirAccountNumber = false;
    // Handling the state logic when redirecting from cop component
    this.setState({
      ...(this.props.displayLoader && { showLoader: true }),
      ...(this.props.isEditCompanyFromCOP && { showAddCompany: true }),
      ...((this.props.isAddCompanyFromCOP ||
        this.props.isEditCompanyFromCOP) && {
        selectedCompany: MoveMoneyPayeeStore.getCompanyDetails(),
      }),
    });
    MoveMoneyPayeeStore.addChangeListener(this.onCompanyStoreChange);
  }

  componentDidMount() {
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_view,
      config.analytics.analytics_event_method_appeared,
      'PageLoaded'
    );
  }

  componentWillReceiveProps() {}

  componentDidUpdate(prevProps, prevState) {
    const compRes = MoveMoneyPayeeStore.getCompanyResponse();
    if (
      !this.state.continueClick &&
      this.refs.noResults &&
      compRes &&
      compRes.billers.length === 0
    ) {
      if (
        this.refs.searchInput &&
        document.activeElement &&
        this.refs.searchInput.id !== document.activeElement.id
      ) {
        this.refs.noResults.focus();
      } else if (
        this.refs.sortCode &&
        this.refs.accountNumber &&
        document.activeElement &&
        !(
          this.refs.sortCode.id === document.activeElement.id ||
          this.refs.accountNumber.id === document.activeElement.id
        )
      ) {
        this.refs.noResults.focus();
      }
    }
  }

  componentWillUnmount() {
    MoveMoneyPayeeStore.removeChangeListener(this.onCompanyStoreChange);
  }
  onAlternativeBlur(e) {
    let parent;
    switch (e.target.name) {
      case 'sort_code':
        let tempRemoveHypen = '';
        theirSortCode = true;
        let Value = String(e.target.value);
        parent =
          e.currentTarget.attributes.getNamedItem('data-parent').textContent;
        if (
          e.target.name === this.props.content.payeeRequestPacket_sort_code &&
          e.target.value !== '' &&
          e.target.value.length === 6
        ) {
          tempRemoveHypen = NumberUtils.formatSortCode(Value);
          let res = tempRemoveHypen.match(/^[0-9-]{0,8}/);
          this.updateValueState(e.target.name, res[0]);
        }
        this.checkError(e.target.name, Value, parent);
        break;
      case 'account_number':
        theirAccountNumber = true;
        let accValue = String(e.target.value);
        let accRes = accValue.match(/^[0-9]{0,8}/);
        this.updateValueState(e.target.name, accRes[0]);
        parent =
          e.currentTarget.attributes.getNamedItem('data-parent').textContent;
        this.checkError(e.target.name, accRes[0], parent);
        break;
    }
  }

  onAlternativeChange(e) {
    let parent;
    this.setState({ isFindButton: false });
    switch (e.target.name) {
      case 'sort_code':
        let res = this.removeHypenFromString(e.target.value).match(
          /^[0-9]{0,6}/
        );
        this.updateValueState(e.target.name, res[0]);
        this.setState({ errorExistSortCode: false });
        e.target.value === ''
          ? this.setState({ emptySortCode: true }, () => {
              this.state.emptyAcctNo &&
                this.setState({ enableDiv: false, continueClick: false });
            })
          : this.setState({ emptySortCode: false });
        if (theirSortCode) {
          parent =
            e.currentTarget.attributes.getNamedItem('data-parent').textContent;
          if (!this.checkError(e.target.name, res[0], parent)) {
            this.setState({ errorExistSortCode: false });
          }
          if (res[0].length === 6) {
            this.setState({ errorExistSortCode: true });
          } else {
            this.setState({ errorExistSortCode: false });
          }
        } else if (res[0].length === 6) {
          this.setState({ errorExistSortCode: true });
        }
        break;
      case 'account_number':
        let accRes = e.target.value.match(/^[0-9]{0,8}/);
        this.updateValueState(e.target.name, accRes[0]);
        this.setState({ errorExistAcctNo: false });
        e.target.value === ''
          ? this.setState({ emptyAcctNo: true }, () => {
              this.state.emptySortCode &&
                this.setState({ enableDiv: false, continueClick: false });
            })
          : this.setState({ emptyAcctNo: false });
        if (theirAccountNumber) {
          parent =
            e.currentTarget.attributes.getNamedItem('data-parent').textContent;
          if (!this.checkError(e.target.name, accRes[0], parent)) {
            this.setState({ errorExistAcctNo: false });
          }
          if (accRes[0].length === 8) {
            this.setState({ errorExistAcctNo: true });
            this.forceUpdate();
          } else {
            this.setState({ errorExistAcctNo: false });
          }
        } else if (accRes[0].length === 8) {
          this.setState({ errorExistAcctNo: true });
        }
        break;
    }
  }

  onBlur(e) {
    this.setState({ companySearchValue: e.target.value.trim() });
  }

  onCompanyStoreChange() {
    const response = MoveMoneyPayeeStore.getCompanyResponse();
    companyResponse = response.billers;
    this.setState({ isFindButton: true });
    if (response.code === 201) {
      this.setState({ loaderCss: '', continueClick: false, enableDiv: true });
      if (companyResponse.length === 0) {
        this.setState({ continueClick: false });
      } else {
        this.setState({ continueClick: true });
      }
    } else if (response.code === 409) {
      this.setState({
        showAddCompany: false,
        enableDiv: false,
        companyListError: true,
        companyErrorResponse: _.get(response, 'error.message', ''),
      });
    }

    if (this.state.selectedCompany) {
      this.setState({ showAddCompany: true, showLoader: false });
    }
  }

  onFocus(e) {
    this.setState({ isFindButton: false });
  }

  onInputCompanyChange(e) {
    let nameRes = String(e.target.value);
    let nameData = '';
    if (nameRes[0] !== undefined) {
      nameData = nameRes[0].replace(/\s\s+/g, ' ');
    }
    this.setState({ isFindButton: false });
    if (e.target.value === '') {
      this.setState({
        continueClick: false,
        enableDiv: false,
        enableSearch: false,
        companySearchValue: nameData.trim(),
      });
    } else if (nameData.length > 0 && nameData.charAt(0) === ' ') {
      this.setState({
        continueClick: false,
        enableDiv: false,
        enableSearch: false,
        companySearchValue: nameData.trim(),
      });
    } else {
      this.setState({ enableSearch: true, companySearchValue: e.target.value });
    }
  }

  getResultText(benificariesLength) {
    let res = 'Results';
    if (benificariesLength === 1) res = 'Result';

    return res;
  }

  accountNumSortCodeField() {
    let sortcodeValue = this.state.sort_code;

    return (
      <div className="row">
        <div className="col-md1-24 c-lookup__sortcode">
          <div
            className="c-field c-lookup__field c-lookup__field--sortcode"
            ref="sortCodeErr"
          >
            <label
              className="c-field__label c-field__label--block"
              htmlFor="sortCode"
            >
              {this.props.content.theirSortCode}
            </label>
            <div className="c-field__controls c-lookup__field__sortcodecontrols">
              <input
                className="c-field__input c-lookup__field__controls__search"
                onBlur={this.onAlternativeBlur}
                data-parent="sortCodeErr"
                type="text"
                name={this.props.content.payeeRequestPacket_sort_code}
                id="sortCode"
                onFocus={this.onFocus}
                onChange={this.onAlternativeChange}
                maxLength="8"
                size="8"
                value={sortcodeValue}
                ref="sortCode"
                aria-invalid="false"
                aria-live="sortCodeErr1"
              />
              <div
                role="alert"
                id="sortCodeErr1"
                className="c-field__message"
                ref={this.props.content.payeeRequestPacket_sort_code}
              />
            </div>
          </div>

          <div
            className="c-field c-lookup__field c-lookup__field--sortcode"
            ref="accNumErr"
          >
            <label
              className="c-field__label c-field__label--block"
              htmlFor="accNo"
            >
              {this.props.content.theirAccountNo}
            </label>
            <div className="c-field__controls c-lookup__field__sortcodecontrols">
              <input
                className="c-field__input c-lookup__field__controls__search"
                onBlur={this.onAlternativeBlur}
                onFocus={this.onFocus}
                data-parent="accNumErr"
                type="text"
                name={this.props.content.payeeRequestPacket_account_number}
                id="accNo"
                onChange={this.onAlternativeChange}
                maxLength="8"
                size="8"
                value={this.state.account_number}
                ref="accountNumber"
                aria-live="accNumErr1"
                aria-invalid="false"
              />
              <div
                role="alert"
                id="accNumErr1"
                className="c-field__message"
                ref={this.props.content.payeeRequestPacket_account_number}
              />
            </div>
          </div>

          <div className="c-field c-lookup__field c-lookup__field--sortcode">
            <label
              className="c-field__label c-field__label--block c-lookup--nolabel"
              aria-hidden="true"
              htmlFor="accNo"
            >
              .
            </label>
            <div className="c-field__controls">
              {this.displaySearchButton()}
            </div>
          </div>
        </div>
      </div>
    );
  }

  changeSearchOptions() {
    companyResponse = {};
    if (this.state.isSearchByCompany) {
      this.setState({
        isSearchByCompany: false,
        enableDiv: false,
        selectedCompany: '',
        enableSearch: false,
        companySearchValue: '',
      });
    } else {
      this.setState({
        isSearchByCompany: true,
        sort_code: '',
        account_number: '',
        enableDiv: false,
        selectedCompany: '',
        errorExistAcctNo: false,
      });
    }
  }

  checkError(fieldname, fieldAmount, parent) {
    switch (fieldname) {
      case 'sort_code':
        if (fieldAmount === '' || fieldAmount.length < 6) {
          this.setState({ errorExistSortCode: false });
          this.refs[parent].className += ' c-field--error';
          this.refs[fieldname].innerHTML =
            this.props.content.sortCodeErrorMessage;

          return true;
        } else {
          this.setState({ errorExistSortCode: true });
          this.refs[parent].className =
            'c-field c-lookup__field c-lookup__field--sortcode';
          this.refs[fieldname].innerHTML = '';

          return false;
        }
      case 'account_number':
        if (fieldAmount === '' || fieldAmount.length < 8) {
          this.setState({ errorExistAcctNo: false });
          this.refs[parent].className += ' c-field--error';
          this.refs[fieldname].innerHTML =
            this.props.content.accountNumberErrorMessage;
          return true;
        } else {
          this.setState({ errorExistAcctNo: true });
          this.refs[parent].className =
            'c-field c-lookup__field c-lookup__field--sortcode';
          this.refs[fieldname].innerHTML = '';
          return false;
        }
    }
  }

  closeCompanyError() {
    this.setState({
      companyListError: false,
      showAddCompany: false,
      addPayeeManuallyFlag: false,
      loaderCss: '',
    });

    this.props.onErrorModalClose();
  }
  companySearchField() {
    return (
      <div className="c-field c-lookup__field">
        <label
          className="c-field__label c-field__label--block"
          htmlFor="lookup1"
        >
          Company name
          <div className="c-field__instructions">
            {this.props.content.addCompany}
          </div>
        </label>

        <div className="c-field__controls">
          <div className="row">
            <div className="col-md1-18 c-lookup__field__controls">
              <input
                id="lookup1"
                type="text"
                placeholder=""
                ref="searchInput"
                className="c-field__input c-lookup__field__controls__search"
                onChange={this.onInputCompanyChange}
                onFocus={this.onFocus}
                value={this.state.companySearchValue}
                maxLength="50"
                size="50"
              />

              {this.displaySearchButton()}
            </div>
          </div>
        </div>
      </div>
    );
  }

  continueButton() {
    let doErrorExist = false;
    if (!this.props.accntSelection) {
      this.props.showInlineError('accntErr', 'dropdown-custom-menu', true);
      window.scrollTo(0, 0);
      doErrorExist = true;
    }
    if (!doErrorExist) {
      const {
        selectedCompany: { account_number, sort_code },
      } = this.state;
      MoveMoneyPayeeActionCreator.verifySRDPayee(
        `${sort_code}${account_number}`
      );
      this.showHeader(false);
      this.setState({ showLoader: true });
      MoveMoneyPayeeStore.emptySearchCompanyData();
    }
  }

  dataChange(val) {
    this.setState({ isFindButton: false });
    if (val !== undefined) {
      this.setState({
        selectedCompany: val,
        showAddCompany: false,
      });
    }
  }

  displayContinueButton() {
    return this.state.continueClick ? (
      <button
        className="c-btn c-btn--default"
        disabled={!this.state.selectedCompany}
        onClick={this.continueButton}
        data-test-id="add-company-continue-button"
      >
        <span>Continue</span>
      </button>
    ) : (
      ''
    );
  }

  displaySearchAlternate() {
    return (
      <div className="c-lookup__option">
        <p>
          Or
          <a href="javascript:void(0);" onClick={this.changeSearchOptions}>
            {this.state.isSearchByCompany
              ? this.props.content.alternativeText
              : this.props.content.alternativeCompanyText}
          </a>
        </p>
      </div>
    );
  }

  displaySearchButton() {
    let disabledClass = true;
    if (this.state.isSearchByCompany) {
      disabledClass = !this.state.enableSearch;
    } else {
      if (this.state.errorExistAcctNo && this.state.errorExistSortCode) {
        disabledClass = false;
      }
    }
    return (
      <button
        aria-labelledby={this.findByCompName}
        className={`c-btn c-btn--default c-btn${this.state.loaderCss} c-lookup__field__controls__btn`}
        disabled={disabledClass}
        onClick={this.findCompanyButton}
        data-test-id="add-company-find-button"
      >
        {this.state.loaderCss === '--loading' ? (
          <span>
            <SvgIcon
              id="icon-refresh"
              width="24px"
              height="24px"
              className="loader-icon"
            />
            Finding...
          </span>
        ) : (
          <span>Find company</span>
        )}
      </button>
    );
  }

  enterManually() {
    let errorCheck = false;
    if (!this.props.accntSelection) {
      this.props.showInlineError('accntErr', 'dropdown-custom-menu', true);
      window.scrollTo(0, 0);
      errorCheck = true;
    } else if (!errorCheck) {
      this.showHeader(false);
      detailsforManualEntry.accountNumber = this.state.account_number;
      detailsforManualEntry.sortCode = this.state.sort_code;
      detailsforManualEntry.companyText = this.state.companySearchValue;

      this.setState({ addPayeeManuallyFlag: true });
    }
  }

  findCompanyButton() {
    if (!this.state.isSearchByCompany) {
      let replacedSortCode = this.refs.sortCode.value.replace(/-/g, '');
      this.setState({
        showAddCompany: false,
        companyListError: false,
        loaderCss: '--loading',
        selectedCompany: '',
      });
      MoveMoneyPayeeActionCreator.getCompanyListFromSortcode(
        replacedSortCode,
        this.refs.accountNumber.value
      );
    } else {
      this.setState({
        showAddCompany: false,
        companyListError: false,
        loaderCss: '--loading',
        selectedCompany: '',
      });
      MoveMoneyPayeeActionCreator.getCompanyListFromName(
        this.state.companySearchValue.trim()
      );
    }
  }

  goBackToMoveMoney() {
    this.props.goBackToMoveMoney();
    MoveMoneyPayeeStore.resetStore();
  }

  goBackToSearchCompany() {
    this.setState({
      showAddCompany: false,
      addPayeeManuallyFlag: false,
      selectedCompany: '',
    });
    this.showHeader(true);
  }

  goToManagePayees() {
    this.props.goToManagePayees();
  }

  goToMoveMoneyPage() {
    this.props.goToMoveMoneyPage();
  }

  showCopComponent(formData, comingFromCompanySearch) {
    this.props.showCopComponent(formData, comingFromCompanySearch);
  }
  removeHypenFromString(value) {
    let sortedValue = '';
    _.map(value, (data) => {
      if (data !== '-') {
        sortedValue += data;
      }
    });
    return sortedValue;
  }

  showHeader(val) {
    this.props.showHeader(val);
  }

  showInlineError(parent, name, isShowError) {
    this.props.showInlineError(parent, name, isShowError);
  }

  // updating the store value
  updateValueState(name, value) {
    this.setState({
      [name]: value,
    });
  }

  render() {
    let renderContent;
    let enableDivOption;
    // to search on the basis of display_name
    if (this.state.enableDiv) {
      if (companyResponse === undefined) {
        enableDivOption = '';
      } else if (companyResponse.length === 0) {
        enableDivOption = (
          <div className="c-lookup__result">
            <div className="c-lookup__resultcount">
              <span>
                <strong>Choose company</strong>
              </span>
            </div>
            <div className="c-lookup__result">
              <ul className="c-lookup__result__list">
                <li className="c-lookup__result__list__itemwrapper end-message end-message--norecords">
                  <p
                    ref="noResults"
                    tabIndex="0"
                    className="u-visually-hidden off-screen"
                  >
                    {NO_RESULTS_FOUND}
                  </p>
                  <p className="c-lookup--result__list__item__data">
                    {NO_RESULTS_FOUND}
                  </p>
                </li>
                <li className="c-lookup__result__list__itemwrapper end-message">
                  <p className="c-lookup--result__list__item__data">
                    Company not shown? Try searching again or{' '}
                    <a href="javascript:void(0);" onClick={this.enterManually}>
                      enter their details manually
                    </a>
                    .
                  </p>
                </li>
              </ul>
            </div>
            {this.displayContinueButton()}
          </div>
        );
      } else {
        let benificariesLength = companyResponse.length;
        let companySearchList = companyResponse.map((searchDataItem, index) => {
          const searchComponent = (
            <CompanyListCard
              key={index}
              data={searchDataItem}
              index={index}
              onClick={this.dataChange}
              selectedData={this.state.selectedCompany}
              isButton={this.state.isFindButton}
            />
          );
          return searchComponent;
        });
        enableDivOption = (
          <div className="c-lookup__result">
            <div className="c-lookup__resultcount">
              <span>
                <strong>Choose company</strong>
              </span>
              <span className="text-count">
                {benificariesLength} {this.getResultText(benificariesLength)}
              </span>
            </div>
            <div className="c-lookup__result">
              <ul className="c-lookup__result__list">
                {companySearchList}
                <li className="c-lookup__result__list__itemwrapper end-message">
                  <p className="c-lookup--result__list__item__data">
                    Company not shown? Try searching again or{' '}
                    <a href="javascript:void(0);" onClick={this.enterManually}>
                      enter their details manually
                    </a>
                    .
                  </p>
                </li>
              </ul>
            </div>
            {this.displayContinueButton()}
          </div>
        );
      }
    }
    if (this.state.addPayeeManuallyFlag) {
      renderContent = (
        <AddPersonComponent
          setNickNameStatus={this.props.setNickNameStatus}
          manualDetails={detailsforManualEntry}
          companyData={this.state.selectedCompany}
          content={this.props.content}
          comingFromCompanySearch
          goBackToSearchCompany={this.goBackToSearchCompany}
          goToManagePayees={this.goToManagePayees}
          goToMoveMoneyPage={this.goToMoveMoneyPage}
          showCopComponent={this.showCopComponent}
          showHeader={this.showHeader}
          accntSelection={this.props.accntSelection}
          isEditCOP={this.props.tryCount > 1}
          keyFieldsChanged={this.props.keyFieldsChanged}
        />
      );
    } else if (this.state.showAddCompany && this.state.selectedCompany) {
      renderContent = (
        <div>
          <ReviewCompany
            setNickNameStatus={this.props.setNickNameStatus}
            updateIsEditCompanyFromCOP={this.props.updateIsEditCompanyFromCOP}
            companyData={this.state.selectedCompany}
            content={this.props.content}
            goBackToSearchCompany={this.goBackToSearchCompany}
            goToManagePayees={this.goToManagePayees}
            goToMoveMoneyPage={this.goToMoveMoneyPage}
            showCopComponent={this.showCopComponent}
            isAddCompanyFromCOP={this.props.isAddCompanyFromCOP}
            isEditCompanyFromCOP={this.props.isEditCompanyFromCOP}
          />
        </div>
      );
    } else if (this.state.companyListError) {
      let footerButtons = (
        <div>
          <button
            className="c-btn c-btn--default c-modal__button"
            onClick={this.closeCompanyError}
          >
            OK
          </button>
        </div>
      );
      renderContent = (
        <PatternLibModalComponent
          show={this.state.companyListError}
          customClass={'c-modal'}
          onHide={() => this.closeCompanyError()}
          bsSize={'medium'}
          modalHeading={''}
          modalBody={this.state.companyErrorResponse}
          modalFooter={footerButtons}
          modalInContainer={false}
          closeButton
        />
      );
    } else {
      renderContent = (
        <div className="c-lookup">
          {this.state.isSearchByCompany
            ? this.companySearchField()
            : this.accountNumSortCodeField()}
          {this.displaySearchAlternate()}
          <div className="row">
            <div className="col-sm2-18">{enableDivOption}</div>
          </div>
        </div>
      );
    }

    return (
      <div>
        {this.state.showLoader ? (
          <LoaderComponent type="large" />
        ) : (
          renderContent
        )}
      </div>
    );
  }
}
AddCompanyComponent.propTypes = {
  addPayeeManuallyFlag: PropTypes.bool,
  content: PropTypes.object,
  showHeader: PropTypes.func,
  goToManagePayees: PropTypes.func,
  goToMoveMoneyPage: PropTypes.func,
  goBackToMoveMoney: PropTypes.func,
  tryCount: PropTypes.number,
  updateIsEditCompanyFromCOP: PropTypes.func,
  keyFieldsChanged: PropTypes.func,
  onErrorModalClose: PropTypes.func.isRequired,
};
AddCompanyComponent.defaultProps = {
  content: {},
  addPayeeManuallyFlag: false,
};

export default AddCompanyComponent;
